import React from 'react'

export const HomeStyles: { [key: string]: React.CSSProperties } = {
    container: { width: '100%', position: 'relative' },
    topTitleContaier: {
        paddingTop: 20,
        display: 'flex',
        paddingLeft: 25,
        paddingRight: 25,
        borderRadius: 15,
        paddingBottom: 20,
        alignItems: 'center',
        backgroundColor: '#184287',
        justifyContent: 'flex-start',
    },
    topTitileTextContianer: { marginLeft: 30 },
    gridContent: {
        position: 'relative',
        paddingBottom: 5,
        flexWrap: 'wrap',
        display: 'flex',
        paddingRight: 3,
        paddingLeft: 3,
        paddingTop: 5,
        gap: 15,
    },
    gridTransactionContent: {
        flex: 1,
        minWidth: 300,
        borderRadius: 10,
        overflow: 'auto',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 1px 3px 0px #0000001A',
    },
    gridRightContent: {
        flex: 1,
        gap: 20,
        width: '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
    },
    gridRightItemContent: {
        minWidth: 100,
        width: '100%',
        borderRadius: 10,
        position: 'relative',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 1px 3px 0px #0000001A',
    },
    section: {
        marginBottom: 35,
    },
    planSuccesContainer: {
        textAlign: 'center',
        width: '100%',
    },
}
